import { render, staticRenderFns } from "./Physicalfitness.vue?vue&type=template&id=5bc17c27&scoped=true"
import script from "./Physicalfitness.vue?vue&type=script&lang=js"
export * from "./Physicalfitness.vue?vue&type=script&lang=js"
import style0 from "./Physicalfitness.vue?vue&type=style&index=0&id=5bc17c27&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc17c27",
  null
  
)

export default component.exports